import { withStyles } from '@material-ui/core';

import FieldRow from './component';
import styles from './styles';

export default withStyles(styles)(FieldRow);
